"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Observable_1 = require("rxjs/Observable");
var overview_helper_service_1 = require("../../../common/service/overview-helper.service");
var operators_1 = require("rxjs/operators");
var overview_field_type_1 = require("../../../common/model/overview-field-type");
var overview_config_item_model_1 = require("../../../common/model/overview-config-item.model");
var overview_card_type_1 = require("../../../common/model/overview-card-type");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
/**
 * Component for showing single overview card
 */
var OverviewItemComponent = /** @class */ (function () {
    function OverviewItemComponent(overviewHelperService) {
        this.overviewHelperService = overviewHelperService;
        this.clickEvent = new core_1.EventEmitter();
        this.portfolioEditEvent = new core_1.EventEmitter();
        this.deleteEvent = new core_1.EventEmitter();
        this.initialized = false;
        this.OverviewCardType = overview_card_type_1.OverviewCardType;
        this.OverviewPortfolioFieldType = overview_field_type_1.OverviewPortfolioFieldType;
    }
    OverviewItemComponent.prototype.ngOnInit = function () {
        this.initialized = true;
        this.setChildEntities();
    };
    OverviewItemComponent.prototype.onDelete = function () {
        this.deleteEvent.emit();
    };
    OverviewItemComponent.prototype.onEdit = function (isConfig, isCardEdit) {
        if (!this.rootEntity && isConfig && isCardEdit) {
            // when editing a card overview
            this.clickEvent.emit(null);
        }
        else if (!this.rootEntity && isConfig && !isCardEdit) {
            // when editing portfolio
            this.portfolioEditEvent.emit(null);
        }
        else if (this.rootEntity && !isConfig) {
            this.clickEvent.emit(null);
        }
    };
    OverviewItemComponent.prototype.setChildEntities = function () {
        var _this = this;
        this.childEntities$ = !this.rootEntity || this.config.cardType.id === overview_card_type_1.OverviewCardType.CUSTOM_CARD ||
            this.config.cardType.id === overview_card_type_1.OverviewCardType.MAIN_CARD
            ? Observable_1.Observable.of([]) :
            this.overviewHelperService.getEntitiesByRootInstanceId(this.config.itemCategoryName, this.rootCategoryName, this.rootEntity && this.rootEntity.getInstanceId(), this.config);
        this.childEntities$ = this.childEntities$.pipe(operators_1.tap(function (entities) { return _this.childEntitiesCount = entities.length; }));
    };
    OverviewItemComponent.prototype.ngOnDestroy = function () {
        this.clickEvent.complete();
        this.deleteEvent.complete();
        this.portfolioEditEvent.complete();
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", idm_de_service_client_js_1.MainEntity)
    ], OverviewItemComponent.prototype, "rootEntity", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], OverviewItemComponent.prototype, "rootCategoryName", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", overview_config_item_model_1.OverviewConfigItemModel)
    ], OverviewItemComponent.prototype, "config", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], OverviewItemComponent.prototype, "clickEvent", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], OverviewItemComponent.prototype, "portfolioEditEvent", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], OverviewItemComponent.prototype, "deleteEvent", void 0);
    OverviewItemComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-overview-item',
            styles: [require('./overview-item.component.css')],
            template: require('./overview-item.component.html'),
        }),
        __metadata("design:paramtypes", [overview_helper_service_1.OverviewHelperService])
    ], OverviewItemComponent);
    return OverviewItemComponent;
}());
exports.OverviewItemComponent = OverviewItemComponent;
//# sourceMappingURL=overview-item.component.js.map